import { OPTIONS, OPTIONS_INTEGRATION, PUBLIC_OPTIONS_INTEGRATION } from 'app-constants'
import { http } from 'hooks'

export function passwordService() {
  function changePassword(data) {
    return http.put('/v1/customers/password', data, OPTIONS_INTEGRATION)
  }

  function resetPassword(data) {
    return http.post('/v1/customers/password/reset/', data, PUBLIC_OPTIONS_INTEGRATION)
  }

  function sendPasswordRecoverySms(data) {
    return http.post('/v1/customers/password/reset/send', data, PUBLIC_OPTIONS_INTEGRATION)
  }

  function confirmPasswordRecoveryToken(data) {
    return http.post('/v1/customers/password/reset/confirm', data, PUBLIC_OPTIONS_INTEGRATION)
  }

  function changePasswordOnFirstAccess(params) {
    return http.put(`/v1/customers/password/first-access`, params, OPTIONS)
  }

  function getRequiredPasswordUpdate(brand) {
    return http.get('/v1/password-update', {
      params: { brand },
      ...OPTIONS_INTEGRATION,
    })
  }

  return {
    changePassword,
    resetPassword,
    sendPasswordRecoverySms,
    confirmPasswordRecoveryToken,
    changePasswordOnFirstAccess,
    getRequiredPasswordUpdate,
  }
}
